import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, useUniqueId } from "@wsui/base";
import { normalizeOptions, FormToggleButtonGroupField } from "@wsui/form";
import { Formik, Form } from "formik";
import { useMenu, useInstantSearch } from "react-instantsearch-hooks";
function MenuButtonGroup(props) {
  var _a;
  props = useThemeProps({
    name: "AlgoliaMenuButtonGroup",
    props
  });
  let {
    attribute,
    options,
    id,
    emptyOption,
    buttonProps,
    ...restProps
  } = props;
  const {
    items,
    // createURL,
    refine
    // canRefine,
    // isShowingMore,
    // toggleShowMore,
    // canToggleShowMore,
    // sendEvent,
  } = useMenu(props);
  const {
    results
  } = useInstantSearch();
  let forwardedOptions;
  id = useUniqueId(id, "search-menu-button-group");
  if (options) {
    forwardedOptions = normalizeOptions(options, {
      emptyOption
    }).map(item => {
      let {
        value: value2,
        label,
        count
        // isRefined,
      } = {
        ...items.find(i => i.value === item.value),
        ...item
      };
      if (value2 === "") {
        count = count ?? items.reduce((sum, item2) => sum + item2.count, 0);
      }
      return {
        value: value2,
        label: typeof label === "function" ? label(item, items) : label,
        count: typeof count === "function" ? count(item, items) : count
      };
    });
  } else {
    forwardedOptions = items;
  }
  forwardedOptions = forwardedOptions.map(_ref => {
    let {
      value: value2,
      label,
      count
      // isRefined,
    } = _ref;
    return {
      value: value2,
      label: `${label} (${Number(count) || 0})`,
      disabled: !count
    };
  });
  const value = ((_a = items.find(item => item.isRefined)) == null ? void 0 : _a.value) || "";
  const name = attribute.replace(/\./g, "_");
  if (!results || results.intercepted) {
    return null;
  }
  return /* @__PURE__ */jsx(Formik, {
    initialValues: {
      [name]: value
    },
    onSubmit: async values => {
      if (value !== values[name]) {
        refine(values[name] || "");
      }
    },
    children: _ref2 => {
      let {
        submitForm
      } = _ref2;
      return /* @__PURE__ */jsx(Form, {
        children: /* @__PURE__ */jsx(FormToggleButtonGroupField, {
          id,
          options: forwardedOptions,
          name,
          buttonProps: {
            onMouseUp: () => {
              setTimeout(submitForm, 0);
            },
            ...buttonProps
          },
          ...restProps
        })
      });
    }
  });
}
export { MenuButtonGroup as default };